import { ContentTag, provideComponent } from "scrivito"

import { CenterWidget } from "./CenterWidgetClass"

provideComponent(CenterWidget, ({ widget }) => {
  return (
    <ContentTag
      className="center-widget"
      content={widget}
      attribute="content"
    />
  )
})
